// extracted by mini-css-extract-plugin
export default {"Stopwatch":"stopwatch_Stopwatch__GxcLQ","watch":"stopwatch_watch__iin8S","label":"stopwatch_label__URpbo"};